import React from 'react';
import BlogView from './components/views/BlogView';
import BlogPostView from './components/views/BlogPostView';
import StaticPageView from './components/views/StaticPageView';
import HelpView from './components/views/HelpView';
import HelpArticleView from './components/views/HelpArticleView';
import HelpCategoryView from './components/views/HelpCategoryView';
import { BlogCacheProvider } from './context/BlogCacheContext';
import './App.css';

export default function Blog() {
  const path = window.location.pathname;

  const handleNavigate = (destination) => {
    if (destination === 'landing') {
      window.location.href = '/';
    } else if (destination === 'blog') {
      window.location.href = '/blog';
    } else if (destination === 'help') {
      window.location.href = '/help';
    }
  };

  return (
    <BlogCacheProvider>
      {(() => {
        // Check for help category URL: /help/category/slug
        const helpCategoryMatch = path.match(/^\/help\/category\/([a-zA-Z0-9-]+)$/);
        if (helpCategoryMatch) {
          const categorySlug = helpCategoryMatch[1];
          return <HelpCategoryView categorySlug={categorySlug} />;
        }

        // Check for help article URL: /help/slug
        const helpArticleMatch = path.match(/^\/help\/([a-zA-Z0-9-]+)$/);
        if (helpArticleMatch) {
          const slug = helpArticleMatch[1];
          return <HelpArticleView slug={slug} onNavigate={handleNavigate} />;
        }

        // Check for help homepage: /help or /help/
        if (path === '/help' || path === '/help/') {
          return <HelpView />;
        }

        // Check for blog post URL: /blog/slug
        const blogPostMatch = path.match(/^\/blog\/([a-zA-Z0-9-]+)$/);
        if (blogPostMatch) {
          const slug = blogPostMatch[1];
          return <BlogPostView slug={slug} onNavigate={handleNavigate} />;
        }

        // Check for blog homepage: /blog or /blog/
        if (path === '/blog' || path === '/blog/') {
          return <BlogView />;
        }

        // Check for static pages: /slug
        const staticPageMatch = path.match(/^\/([a-zA-Z0-9-]+)$/);
        if (staticPageMatch) {
          const slug = staticPageMatch[1];
          return <StaticPageView slug={slug} onNavigate={handleNavigate} />;
        }

        // Default to blog homepage
        return <BlogView />;
      })()}
    </BlogCacheProvider>
  );
}
